const CircleClockIcon = ({ className }) => (
    <div className={className}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
            id="Circle-Clock--Streamline-Flex"
        >
            <desc>
                {'Circle Clock Streamline Icon: https://streamlinehq.com'}
            </desc>
            <g id="circle-clock--clock-loading-measure-time-circle">
                <path
                    id="Vector"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7 13.5c4.16 0 6.5 -2.34 6.5 -6.5S11.16 0.5 7 0.5 0.5 2.84 0.5 7s2.34 6.5 6.5 6.5Z"
                    strokeWidth={1}
                />
                <path
                    id="Vector 12"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7.03125 3.96191v3.05534l1.8332 1.83321"
                    strokeWidth={1}
                />
            </g>
        </svg>
    </div>
);

export default CircleClockIcon;
